import { render, staticRenderFns } from "./CharacterLink.vue?vue&type=template&id=52130eb8&"
import script from "./CharacterLink.vue?vue&type=script&lang=ts&"
export * from "./CharacterLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports